export default "__VITE_ASSET__f6cdce95__"